
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

/**
 * Componente de modal que mantem a referencia ao componente
 * mesmo quando o pai muda. Isso evita que o componente
 * seja re-renderizado quando o pai muda, o que pode causar
 * problemas de performance.
 *
 * @param {boolean} open - Se o modal esta aberto ou fechado.
 * @param {function} handleClose - Função para fechar o modal.
 * @param {function} onResult - Função que recebe o resultado da
 * acao do usuario (true para confirmar, false para cancelar).
 * @returns {JSX.Element} - O componente de modal.
 */
export default function KeepMountedModal({ open, handleClose, onResult }) {
/**
 * Função chamada quando o usuário confirma a ação.
 * Retorna 'true' e fecha o modal.
 */
  const handleConfirmClick = () => {
    onResult(true); // Retorna 'true'
    handleClose(); // Fecha o modal
  };

  const handleCancelClick = () => {
    onResult(false); // Retorna 'false'
    handleClose(); // Fecha o modal
  };

  return (
    <Modal
      keepMounted
      open={open} 
      onClose={handleCancelClick} 
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Box sx={style}>
        <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
          Confirmar Ação
        </Typography>
        <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
          Você deseja confirmar esta etapa?
        </Typography>

        
        <Stack
          direction="row"
          spacing={2}
          sx={{ mt: 4, justifyContent: "flex-end" }} 
        >
          <Button variant="outlined" color="error" onClick={handleCancelClick}>
            Cancelar (Falso)
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirmClick}
          >
            Confirmar (Verdadeiro)
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
}
